class WSliderStickers extends HTMLElement {
  connectedCallback() {
    if (this._initialized) return;
    this._initialized = true;
    this._swiper = null;
    this._swiperEl = this.querySelector('.w-slider-stickers__swiper');
    if (!this._swiperEl) return;

    const breakpoint = Number.parseInt(this.dataset.breakpoint, 10);
    this._breakpoint = Number.isNaN(breakpoint) ? 989 : breakpoint;
    this._mq = window.matchMedia(`(min-width: ${this._breakpoint}px)`);
    this._onChange = this._onChange.bind(this);

    this._onChange(this._mq);
    this._bindMediaQuery();
  }

  disconnectedCallback() {
    this._unbindMediaQuery();

    this._destroy();
    this._initialized = false;
  }

  _bindMediaQuery() {
    if (!this._mq) return;

    if (typeof this._mq.addEventListener === 'function') {
      this._mq.addEventListener('change', this._onChange);
      this._mqListenerMode = 'event';
      return;
    }

    this._mq.onchange = this._onChange;
    this._mqListenerMode = 'onchange';
  }

  _unbindMediaQuery() {
    if (!this._mq) return;

    if (this._mqListenerMode === 'event' && typeof this._mq.removeEventListener === 'function') {
      this._mq.removeEventListener('change', this._onChange);
      this._mqListenerMode = null;
      return;
    }

    if (this._mqListenerMode === 'onchange' && this._mq.onchange === this._onChange) {
      this._mq.onchange = null;
      this._mqListenerMode = null;
    }
  }

  _onChange(event) {
    if (event.matches) {
      this._destroy();
      return;
    }

    this._init();
  }

  _init() {
    if (this._swiper || !this._swiperEl || typeof Swiper === 'undefined') return;

    this._swiper = new Swiper(this._swiperEl, {
      slidesPerView: 'auto',
      spaceBetween: 8,
      initialSlide: 1,
      centeredSlides: true,
      loop: false
    });
  }

  _destroy() {
    if (!this._swiper) return;

    this._swiper.destroy(true, true);
    this._swiper = null;
  }
}

if (!customElements.get('w-slider-stickers')) {
  customElements.define('w-slider-stickers', WSliderStickers);
}
